import { BaseChatPackage } from '../utils'
import { ChatsServices } from './chats'
import { MessagesServices } from './messages'
import { GroupsServices } from './groups'

export interface ChatServices extends ChatsServices, MessagesServices, GroupsServices {}

export class ChatServices extends BaseChatPackage {
  constructor(...args: ConstructorParameters<typeof BaseChatPackage>) {
    super(...args)
    const chatsService = new ChatsServices(...args)
    const messagesService = new MessagesServices(...args)
    const groupsService = new GroupsServices(...args)
    this.bindMethods(chatsService)
    this.bindMethods(messagesService)
    this.bindMethods(groupsService)
  }
}
